@import url(../../common/css/element.css);
@import url(../../utils/img-previewer/style.css);
.jackery-comment {
  max-width: 800px;
  margin: 0 auto;
  border: 1px solid #f4f6f6 !important;
  padding: 30px;
}

.loading_more_wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.loading_more_wrapper__loading {
  display: block;
  margin: -30px;
}

.load-more__end:hover {
  background: #545454;;
}
.load-more__end {
  opacity: 0.8;
  cursor: not-allowed;
}

@media screen and (max-width: 1024px) {
  .jackery-comment {
    max-width: 100%;
    padding: 0 10px;
  }
}